<template>
    <v-card>
        <v-card-title>
        <span class="headline">Body Type</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newBodyType">
                <v-text-field :label="labels.bodyType" v-model="bodyTypeForm.bodyType" :error-messages="errors.collect('bodyType')" data-vv-name="bodyType" :data-vv-as="labels.bodyType" v-validate="'required|param|max:20'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.bodyType}}</v-subheader>
                <div class="title">{{bodyTypeForm.bodyType}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.description" v-model="bodyTypeForm.bodyTypeDesc" :error-messages="errors.collect('description')" data-vv-name="description" :data-vv-as="labels.description" v-validate="'required|entry|max:40'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'bodyTypeForm': Object,
    'newBodyType': Boolean
  },
  data() {
    return {
      labels: {
        bodyType: 'Body Type Code*',
        description: 'Body Type Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.bodyTypeForm.bodyType = undefined
      this.bodyTypeForm.bodyTypeDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newBodyType) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.vehicle.menu.createBodyType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.bodyTypeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.vehicle.menu.updateBodyType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.bodyTypeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
